import { render, staticRenderFns } from "./tender.vue?vue&type=template&id=04609535&scoped=true&"
import script from "./tender.vue?vue&type=script&lang=js&"
export * from "./tender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04609535",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04609535')) {
      api.createRecord('04609535', component.options)
    } else {
      api.reload('04609535', component.options)
    }
    module.hot.accept("./tender.vue?vue&type=template&id=04609535&scoped=true&", function () {
      api.rerender('04609535', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/tender/tender.vue"
export default component.exports